import Topnav from './components/Nav/TopBar';
import Sidebar from './components/Nav/SideBar';

import AuthToken from './components/Context/AuthToken';
import { useStateContext } from './components/Context/ContextProvider';
import ProtectedRoute from './components/Context/ProtectedRoute'
import AdminRoute from './components/Context/AdminRoute'
import { Routes, Route } from 'react-router-dom';
import Login from './pages/Login'

import Home from './pages/Home';
import ListUsers from './pages/Users/ListUsers'
import AddUsers from './pages/Users/AddUsers'
import UpdateUser from './pages/Users/UpdateUser'
import AirtimeRequests from './pages/Airtime&Bundle/AirtimeRequests'
import BundleRequests from './pages/Airtime&Bundle/BundleRequests'
import BuyAirtime from './pages/Airtime&Bundle/BuyAirtime'
import BuyBundle from './pages/Airtime&Bundle/BuyBundle'
import BuyViaExcel from './pages/Airtime&Bundle/BuyViaExcel'
import ScheduleAirtime from './pages/ScheduleAirtimeBundle/ScheduleAirtime'
import ScheduleBundle from './pages/ScheduleAirtimeBundle/ScheduleBundle'
import ScheduleExcel from './pages/ScheduleAirtimeBundle/ScheduleExcel'
import UpdateScheduled from './pages/ScheduleAirtimeBundle/UpdateScheduled'
import Topups from './pages/Topup/Topups'
import Transactions from './pages/Topup/Transactions'
import ViewBankTransaction from './pages/Topup/ViewBankTransaction'
import MpesaTransactions from './pages/Topup/MpesaTransactions'
import SuccessfulReports from './pages/Reports/SuccessfulReports'
import PendingReports from './pages/Reports/PendingReports'
import Accounts from './pages/Accounts/Accounts'
import TrxLog from './pages/Accounts/TrxLog'
import Utilization from './pages/Utilization'
import Profile from './pages/Users/Profile'


const App = () => {
  const { activeMenu } = useStateContext();
  const { setAccessToken } = AuthToken();

  const token_use = window.localStorage.getItem('token');
  const auth_token = JSON.parse(token_use)?.data.token_use;


  if (auth_token !== 'bearer') {
   return <Login setAccessToken={setAccessToken}/>
  }


  return (
    <main>
      <div className='flex relative'>
        {activeMenu
          ? (
            <div className='lg:w-48 xl:w-56 2xl:w-60 fixed'>
              <Sidebar />
            </div>
            )
          : (
            <div>
              <Sidebar />
            </div>
            )}
        <div className={activeMenu ? 'min-h-screen lg:ml-48 xl:ml-56 2xl:ml-60 w-full' : 'w-full min-h-screen flex-2'}>
          <div>
            <Topnav />
          </div>
          <div>
            <Routes>
              {/* dashboard  */}
              <Route path='/dashboard' element={<Home />} />
              <Route path='/users' element={<ProtectedRoute><ListUsers /></ProtectedRoute>} />
              <Route path='/adduser' element={<ProtectedRoute><AddUsers /></ProtectedRoute>} />
              <Route path='/updateuser/:id' element={<ProtectedRoute><UpdateUser /></ProtectedRoute>} />
              <Route path='/my-profile' element={<Profile />} />
              <Route path='/airtime' element={<AirtimeRequests />} />
              <Route path='/bundle' element={<BundleRequests />} />
              <Route path='/buyairtime' element={<BuyAirtime />} />
              <Route path='/buybundle' element={<BuyBundle />} />
              <Route path='/buyviaexcel' element={<BuyViaExcel />} />
              <Route path='/scheduleairtime' element={<ScheduleAirtime />} />
              <Route path='/schedulebundle' element={<ScheduleBundle />} />
              <Route path='/scheduleviaexcel' element={<ScheduleExcel />} />
              <Route path='/updatescheduled/:id' element={<UpdateScheduled />} />
              <Route path='/successfulreports' element={<SuccessfulReports />} />
              <Route path='/pendingreports' element={<PendingReports />} />
              <Route path='/topups' element={<AdminRoute><Topups /></AdminRoute>} />
              <Route path='/transactions' element={<AdminRoute><Transactions /></AdminRoute>} />
              <Route path='/transaction/:id' element={<AdminRoute><ViewBankTransaction /></AdminRoute>} />
              <Route path='/mpesa-transactions' element={<AdminRoute><MpesaTransactions /></AdminRoute>} />
              <Route path='/accounts' element={<AdminRoute><Accounts /></AdminRoute>} />
              <Route path='/accounts/:id' element={<AdminRoute><TrxLog /></AdminRoute>} />
              <Route path='/utilization' element={<AdminRoute><Utilization /></AdminRoute>} />
            </Routes>
          </div>
        </div>
      </div>
    </main>
  );
};

export default App;
